<h4 mat-dialog-title>Manage Lists: {{ measure }}</h4>
<mat-progress-bar *ngIf="isSaving" mode="indeterminate"></mat-progress-bar>
<mat-dialog-content>
    <div *ngFor="let detail of lists; last as isLast">
        <h4 class="title-case">{{ detail.title }}</h4>
        <mat-progress-bar
            *ngIf="detail.isLoading"
            mode="indeterminate"
        ></mat-progress-bar>
        <span *ngIf="!detail.isLoading && !detail.list.length"
            >You haven't created any {{ detail.title }} Lists.</span
        >
        <mat-selection-list>
            <mat-list-option
                *ngFor="let list of detail.list"
                [(selected)]="list.checked"
                >{{ list.name }}</mat-list-option
            >
        </mat-selection-list>
        <br *ngIf="!isLast" />
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button
        mat-button
        color="primary"
        [disabled]="isLoading"
        (click)="onSave()"
    >
        Save
    </button>
    <button mat-button [mat-dialog-close]="false">Close</button>
</mat-dialog-actions>
